export function setMAPage(state, payload) {
    state.isMAPage = payload
}

export function setAppConfig(state, payload) {
    state.appConfig = payload
}

export function setWindowWidth (state, payload) {
    state.windowWidth = payload;
}

export function setActiveBreakpoints (state) {
    const activeBreakpoints = [];
    const windowWidth = state.windowWidth;
    for (const [key, value] of Object.entries(state.breakpoints)) {
        if (value <= windowWidth) {
            activeBreakpoints.push(key);
        } else {
            break;
        }
    }
    if (activeBreakpoints.length !== state.activeBreakpoints.length) {
        state.activeBreakpoints = activeBreakpoints;
    }
}

export function setPortableDevice(state, payload) {
    state.portableDevice = payload;
}

export function setMobile(state) {
    state.mobile = !state.activeBreakpoints.includes('tablet');
}

export function setDim(state, payload) {
    state.dimmed = payload;
}

export function setLock(state, payload) {
    if (state.locked === payload) {
        return;
    }
    if (payload) {
        state.scrollPos = {
            x: window.scrollX,
            y: window.scrollY,
        };
        document.querySelector('.site').style.top = -state.scrollPos.y + 'px';
        state.locked = payload;
    } else {
        state.locked = payload;
        document.querySelector('.site').style.top = 'auto';

        setTimeout(() => {
            window.scrollTo({
                top: state.scrollPos.y,
                left: state.scrollPos.x,
            });
        }, 15);
    }
}

export function setMobileSidebarHeightMode(state, payload) {
    state.mobileSidebarHeightMode = payload
}

export function setSidebarDetailOpen(state, payload) {
    state.sidebarDetailOpen = payload
}

export function setInterimStopMessageVisible(state, payload) {
    state.interimStopMessageVisible = payload
}

export function setMobileSearchVisible(state, payload) {
    state.mobileSearchVisible = payload
}

export function setDialogAlreadyVisible(state, payload) {
    state.dialogAlreadyVisible = payload
}

